module.exports = __webpack_public_path__ + "img/id.1cfe4160.svg";